import { useMemo } from 'react'
import { useQuery } from '@based/sdk/react'
import { RegionViewModel } from 'functions/app/geography/view/region'
import { isFeatureEnabled } from '@app/util/featureToggle'
import { regionTabs } from '../constants'
import type { RegionFeatures } from '@schema/featureToggle'
import {
  isRegionalLayoutTabAvailable,
  type RegionalLayoutTabAvailabilityContext,
} from './isRegionalLayoutTabAvailable'

export const useRegionalLayoutTabAvailability = (region: RegionViewModel) => {
  const expertsFeatureEnabled = isFeatureEnabled(
    region.featureToggles,
    regionTabs.experts,
  )

  const expertsCountQuery = useQuery(
    expertsFeatureEnabled ? 'list-regional-service-providers' : null,
    { regionId: region.id, count: true },
  )

  const context: RegionalLayoutTabAvailabilityContext = useMemo(
    () => ({
      expertsCount: expertsCountQuery.data?.count ?? 0,
    }),
    [expertsCountQuery.data?.count],
  )

  const isTabAvailable = (tab: RegionFeatures) =>
    isRegionalLayoutTabAvailable(region, tab, context)

  return { isTabAvailable, context }
}
